export const PORTAL_UNIVERSE = 'universe'
export const PORTAL_ESSENTIALS = 'essentials'
export const PORTAL_ACCELERATOR = 'accelerator'
export const LITE_BASE_PATH = '/mvu-lite'
export const LEGACY_LITE_BASE_PATH = '/mvu-essentials'

export function isLitePath(pathname) {
  return [LITE_BASE_PATH, LEGACY_LITE_BASE_PATH].some(basePath => (
    pathname === basePath || pathname?.startsWith(`${basePath}/`)
  ))
}

export function getProductAreaFromPath(pathname) {
  if (isLitePath(pathname)) return 'lite'
  if (String(pathname || '').startsWith('/mvu-accelerator')) return PORTAL_ACCELERATOR
  return PORTAL_UNIVERSE
}

export function replaceLegacyLitePath(pathname) {
  return String(pathname || '').replace(
    /^\/mvu-essentials(?=\/|$)/,
    LITE_BASE_PATH,
  )
}

export function normalizePortal(portal) {
  if (portal === PORTAL_ESSENTIALS || portal === PORTAL_ACCELERATOR) {
    return portal
  }

  return PORTAL_UNIVERSE
}

export function getPortalConfig(portal) {
  const resolvedPortal = normalizePortal(portal)

  const configs = {
    [PORTAL_UNIVERSE]: {
      id: PORTAL_UNIVERSE,
      basePath: '',
      homeRoute: '/dashboard',
      loginRoute: '/login',
      myAccountRoute: '/myaccount',
      certificatesRoute: '/certificates',
      notificationsRoute: '/notifications',
      searchEnabled: true,
      buildQuizRoute: id => `/quiz/${id}`,
      buildSurveyRoute: id => `/survey/${id}`,
    },
    [PORTAL_ESSENTIALS]: {
      id: PORTAL_ESSENTIALS,
      displayName: 'MagVenture Universe Lite',
      shortName: 'Lite',
      basePath: LITE_BASE_PATH,
      homeRoute: LITE_BASE_PATH,
      loginRoute: `${LITE_BASE_PATH}/login`,
      myAccountRoute: null,
      certificatesRoute: `${LITE_BASE_PATH}/certificates`,
      notificationsRoute: `${LITE_BASE_PATH}/notifications`,
      searchEnabled: false,
      buildQuizRoute: id => `${LITE_BASE_PATH}/quiz/${id}`,
      buildSurveyRoute: id => `${LITE_BASE_PATH}/survey/${id}`,
    },
    [PORTAL_ACCELERATOR]: {
      id: PORTAL_ACCELERATOR,
      displayName: 'MagVenture Accelerator Program',
      shortName: 'Accelerator',
      basePath: '/mvu-accelerator',
      homeRoute: '/mvu-accelerator',
      loginRoute: '/mvu-accelerator/login',
      myAccountRoute: '/mvu-accelerator/myaccount',
      certificatesRoute: null,
      notificationsRoute: '/mvu-accelerator/notifications',
      searchEnabled: false,
      buildQuizRoute: id => `/mvu-accelerator/quiz/${id}`,
      buildSurveyRoute: id => `/mvu-accelerator/survey/${id}`,
    },
  }

  return configs[resolvedPortal]
}

export function buildPortalDetailRoute(portal, type, id, lesson) {
  const resolvedPortal = normalizePortal(portal)

  if (!type || !id) return getPortalConfig(resolvedPortal).homeRoute

  if (resolvedPortal === PORTAL_UNIVERSE) {
    return `/mode/${type}/${id}${lesson ? `/${lesson}` : ''}`
  }

  return `${getPortalConfig(resolvedPortal).basePath}/${type}/${id}`
}

export function buildPortalSubCategoryRoute(portal, type, id, subCategoryId) {
  const resolvedPortal = normalizePortal(portal)
  const search = subCategoryId ? `?q=${subCategoryId}` : ''

  if (!type) return getPortalConfig(resolvedPortal).homeRoute

  if (resolvedPortal === PORTAL_UNIVERSE) {
    return id
      ? `/sub-category/${id}/${type}${search}`
      : `/sub-category/${type}${search}`
  }

  return `${getPortalConfig(resolvedPortal).basePath}/details/${type}${id ? `/${id}` : ''}${search}`
}
